import { render } from "./SortCalendarDescending.vue?vue&type=template&id=8ebcdfd6"
import script from "./SortCalendarDescending.vue?vue&type=script&lang=js"
export * from "./SortCalendarDescending.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__